import type { CircleOption } from '@app/types/ui/circular-progress/interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useDisciplineStore } from '@stores/discipline'

import { useAssessmentTestAnalytics } from '@hooks/assessments/assessment-test-analytics.hook'

import { getQuerySearchParam } from '@helpers/query'
import { capitalizeFirstLetter } from '@helpers/string'

interface AssessmentTestCompilingReturn {
  options: CircleOption
  text: ComputedRef<string>
}

export const useAssessmentTestCompiling = (): AssessmentTestCompilingReturn => {

  const disciplineStore = useDisciplineStore()

  const isComprehension = getQuerySearchParam('comprehension_check_up') === '1'
  const { setAssessmentCompilingPageView } = useAssessmentTestAnalytics()

  const text = computed(() => {
    const disciplineCode = disciplineStore.getDisciplineCode?.toLowerCase() || ''
    if (isComprehension) {
      if (disciplineStore.getDisciplineCode === Discipline.Math) {
        return 'We are compiling your child’s math check-up results...'
      } else {
        return 'We are compiling your child’s check-up results...'
      }
    } else {
      return `We are compiling your child’s ${capitalizeFirstLetter(disciplineCode)} assessment results...`
    }
  })

  const options: CircleOption = {
    size: 120,
    stroke: 10,
    speed: 30,
    pauseDuration: 500,
    stops: [{
      value: 30,
      title: text.value,
      text: '',
    },
    {
      value: 60,
      title: text.value,
      text: '',
    },
    {
      value: 90,
      title: text.value,
      text: '',
    },
    {
      value: 100,
      title: text.value,
      text: '',
    }],
  }

  onMounted(() => {
    setAssessmentCompilingPageView()
  })

  return {
    options,
    text,
  }
}
